import AuthLayout from '@/layouts/AuthLayout.vue'
import AuthLayoutPages from '@/layouts/AuthLayoutPages/index.js'

import DashboardLayout from '@/layouts/DashboardLayout.vue'
import DashboardLayoutPages from '@/layouts/DashboardLayoutPages/index.js'




const routes = [
	{
		path: '/',
		redirect: '/login',
		component: AuthLayout,
		name: 'Authentication',
		children: [
			{
				path: '/login',
				name: 'Login',
				component: AuthLayoutPages.Login
			},
		],
	},
	{
		path: '/',
		component: DashboardLayout,
		children: [
			{
				path: 'visao-geral',
				name: 'Visão geral',
				components: { default: DashboardLayoutPages.Overview }
			},
			{
				path: 'categorias',
				name: 'Categorias',
				components: { default: DashboardLayoutPages.Categories }
			},
			{
				path: '/categoria/:id',
				name: 'Categoria',
				components: { default: DashboardLayoutPages.Category },
			},
			{
				path: 'cursos',
				name: 'Cursos',
				components: { default: DashboardLayoutPages.Courses }
			},
			{
				path: '/cursos/:id',
				name: 'Curso',
				components: { default: DashboardLayoutPages.Course },
			},
			{
				path: 'respostas',
				name: 'Respostas',
				components: { default: DashboardLayoutPages.TestResults }
			},
			{
				path: 'artigos',
				name: 'Artigos',
				components: { default: DashboardLayoutPages.Articles }
			},
			{
				path: '/artigos/:id',
				name: 'Artigo',
				components: { default: DashboardLayoutPages.Article },
			},
			{
				path: '/artigos/novo/:courseId',
				name: 'Artigo',
				components: { default: DashboardLayoutPages.Article },
			},
			{
				path: '/artigos/:id/pergunta/:questionId',
				name: 'Pergunta',
				components: { default: DashboardLayoutPages.TestQuestion },
			},
			{
				path: '/artigos/:id/resultado/:resultId',
				name: 'Resultado',
				components: { default: DashboardLayoutPages.TestResult },
			},
			{
				path: 'videos',
				name: 'Vídeos',
				components: { default: DashboardLayoutPages.Videos }
			},
			{
				path: '/videos/:id',
				name: 'Vídeo',
				components: { default: DashboardLayoutPages.Video },
			},
			{
				path: 'contatos',
				name: 'Contatos',
				components: { default: DashboardLayoutPages.Contacts }
			},
			{
				path: 'relatorios',
				name: 'Relatórios',
				components: { default: DashboardLayoutPages.Logs }
			},
			{
				path: 'usuarios',
				name: 'Usuários',
				components: { default: DashboardLayoutPages.Users }
			},
			{
				path: 'administradores',
				name: 'Administradores',
				components: { default: DashboardLayoutPages.Admins }
			},
			{
				path: '/usuario/:id',
				name: 'Usuário',
				components: { default: DashboardLayoutPages.User },
			},
			{
				path: '/administrador/:id',
				name: 'Administrador',
				components: { default: DashboardLayoutPages.Admin },
			},
			{
				path: 'empresas',
				name: 'Empresas',
				components: { default: DashboardLayoutPages.Companies }
			},
			{
				path: '/empresa/:id',
				name: 'Empresa',
				components: { default: DashboardLayoutPages.Company },
			},			
			{
				path: '/empresa/:id/teste/:companyArticleId',
				name: 'Teste',
				components: { default: DashboardLayoutPages.CompanyArticle },
			},		
			{
				path: 'empresa/:id/departamentos',
				name: 'Departamentos',
				components: { default: DashboardLayoutPages.CompaniesDepartments }
			},	
			{
				path: '/empresa/:id/departamento/:companyDepartmentId',
				name: 'Departamento',
				components: { default: DashboardLayoutPages.CompanyDepartment },
			},
			{
				path: 'empresa/:id/filiais',
				name: 'Filiais',
				components: { default: DashboardLayoutPages.CompaniesBranches }
			},	
			{
				path: '/empresa/:id/filial/:companyBranchId',
				name: 'Filial',
				components: { default: DashboardLayoutPages.CompanyBranch },
			},
			{
				path: 'manuais',
				name: 'Novidades',
				components: { default: DashboardLayoutPages.Manuals }
			},
			{
				path: '/manual/:id',
				name: 'Manual',
				components: { default: DashboardLayoutPages.Manual },
			},
			{
				path: '/podcast/:id',
				name: 'Podcast',
				components: { default: DashboardLayoutPages.Podcast },
			},
			{
				path: '/podcasts',
				name: 'Podcast',
				components: { default: DashboardLayoutPages.Podcasts },
			},
			{
				path: '/especialista/:id',
				name: 'Especialista',
				components: { default: DashboardLayoutPages.Specialist },
			},
			{
				path: '/especialistas',
				name: 'Especialistas',
				components: { default: DashboardLayoutPages.Specialists },
			},
			{
				path: '/chat/:id',
				name: 'Chat',
				components: { default: DashboardLayoutPages.Chat },
			},
			{
				path: '/chats',
				name: 'Chats',
				components: { default: DashboardLayoutPages.Chats },
			},
			{
				path: '/lgpd',
				name: 'Lgpd',
				components: { default: DashboardLayoutPages.Lgpd },
			},
			{
				path: '/srq20-emails',
				name: 'Srq20',
				components: { default: DashboardLayoutPages.Srq20Email },
			},
		]
	}
];

export default routes
